import { createTypedStatementHandler } from '../common';
import { SchemaDslBuilder } from './SchemaDslBuilder';
export const createSchemaStatementHandler = (args) => {
    return createTypedStatementHandler(args, SchemaDslBuilder);
};
//# sourceMappingURL=createSchemaStatementHandler.js.map